import React, { useRef } from 'react';
import usePageLayout from '../../hooks/usePageLayout';
import '../403/index.scss';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import ButtonPanelReaction from '../../components/Buttons/ButtonPanelReaction';
import WiwHeaderTitle from '../../components/WiwHeaderTitle';
import url from '../../utils/url';
import { useTranslation } from 'react-i18next';
import LogoSurface from '../../components/Brand/LogoSurface';
import '../../components/Brand/AppFailure.scss';

const { Header, Content, Footer } = Layout;

export default function Page403() {
    const { t } = useTranslation('brand');
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const { contentHeight, contentTop } = usePageLayout(headerRef, footerRef);
    return (
    <Layout className="app-layout error-page">
        <Header className="header" ref={headerRef}><WiwHeaderTitle title="403"></WiwHeaderTitle></Header>
        <Content className="content-layot" style={{ height: contentHeight, top: contentTop }}>
            <div className="access-denied-message">
                <LogoSurface className="app-failure__logo">
                    <img src={`${process.env.PUBLIC_URL || ''}/brand/wiw-loader-poster.png`} alt="" />
                </LogoSurface>
                <h1>403</h1>
                <p>{t('reportUnavailable')}</p>
                <Link to={url('/')}>{t('backToFeed')}</Link>
            </div>
        </Content>
        <Footer ref={footerRef}>
            <ButtonPanelReaction />
        </Footer>
    </Layout>
    )
}
